import React from "react";
import {
    Repeat,
    Ruler,
    History,
    UserCheck,
    Cpu,
    ShieldAlert,
} from "lucide-react";

const ICONS = { Repeat, Ruler, History, UserCheck, Cpu, ShieldAlert };

export const AvoidLLMPanel = ({ examples = [] }) => (
    <section
        data-testid="avoid-llm-panel"
        className="border border-slate-200 bg-white rounded-sm p-8 hover-lift"
    >
        <div className="flex items-start justify-between gap-6 flex-wrap mb-6">
            <div>
                <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                    LLM budget discipline
                </div>
                <h2 className="mt-2 font-heading text-2xl lg:text-3xl font-semibold tracking-tight text-slate-900">
                    When can PromptCierge avoid another LLM call?
                </h2>
            </div>
            <p className="max-w-md text-sm text-slate-600 leading-relaxed">
                As decision routes consolidate, PromptCierge can recommend fewer
                LLM calls — replacing repeated prompting with approved patterns,
                deterministic checks and governed reuse.
            </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {examples.map((ex, i) => {
                const Icon = ICONS[ex.icon] || Cpu;
                return (
                    <div
                        key={i}
                        data-testid={`avoid-example-${i}`}
                        className="border border-slate-200 rounded-sm p-5 bg-slate-50/40 hover:bg-white hover-lift"
                    >
                        <Icon className="h-4 w-4 text-slate-700" />
                        <div className="mt-3 font-heading text-base font-semibold text-slate-900">
                            {ex.title}
                        </div>
                        <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">
                            {ex.body}
                        </p>
                    </div>
                );
            })}
        </div>
    </section>
);

export default AvoidLLMPanel;
